import { createSelector } from 'reselect';
import {
  HEARINGSTATUS_ACTIVE,
  HEARINGSTATUS_AWAITING_CONCLUSION,
  HEARINGSTATUS_AWAITING_STARTDATE,
  HEARINGSTATUS_CONCLUDED,
} from '../../constants/api';
import {
  allHearingsSelector,
  hearingByIdSelector,
} from '../apiFeatures/hearingSlice';
import {
  allHearingStatusSelector,
  hearingStatusByStatusSelector,
} from '../apiFeatures/hearingStatusSlice';
import { getEntityId, getRelId } from '../helpers/apiHelpers';

// This file contains selectors that uses other selectors from different files i.e. composite selectors.
// It is in some cases required to move composite selectors from other slices to this file to avoid circular reference issues
const hearingStatusByHearingIdSelector = (hearingId) =>
  createSelector(
    [allHearingStatusSelector, hearingByIdSelector(hearingId)],
    (hearingStatus, hearing) =>
      hearingStatus.find(
        (s) => getEntityId(s) === getRelId(hearing, 'hearingStatus'),
      ),
  );

const allConcludedHearingsSelector = createSelector(
  [
    allHearingsSelector,
    hearingStatusByStatusSelector(HEARINGSTATUS_AWAITING_CONCLUSION),
    hearingStatusByStatusSelector(HEARINGSTATUS_CONCLUDED),
  ],
  (hearings, concludedStatus, awaitingConclusionStatus) =>
    hearings.filter(
      (h) =>
        getRelId(h, 'hearingStatus') === getEntityId(concludedStatus) ||
        getRelId(h, 'hearingStatus') === getEntityId(awaitingConclusionStatus),
    ),
);

const allActiveHearingsSelector = createSelector(
  [
    allHearingsSelector,
    hearingStatusByStatusSelector(HEARINGSTATUS_ACTIVE),
    hearingStatusByStatusSelector(HEARINGSTATUS_AWAITING_STARTDATE),
  ],
  (hearings, activeStatus, awaitingStartDateStatus) =>
    hearings.filter(
      (h) =>
        getRelId(h, 'hearingStatus') === getEntityId(activeStatus) ||
        getRelId(h, 'hearingStatus') === getEntityId(awaitingStartDateStatus),
    ),
);

export {
  hearingStatusByHearingIdSelector,
  allActiveHearingsSelector,
  allConcludedHearingsSelector,
};
